import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as fromComponents from './components';
import { SharedModule } from '@shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CoreModule } from '@core/core.module';
import { ErrorComponent } from './components/error/error.component';
import { FooterModule } from './components/footer/footer.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [fromComponents.components, ErrorComponent],
  exports: [fromComponents.components],
  imports: [CommonModule, SharedModule, ReactiveFormsModule, ReactiveFormsModule,
    CoreModule, FontAwesomeModule, TranslateModule, FooterModule]
})
export class MainModule { }
